// Icon mapping utility - Maps template icon strings to Lucide React components
// Used to replace emoji icons with Lucide icons

import React from 'react';
import {
  Play,
  SquarePause,
  StepForward,
  Check,
  Heart,
  Lightbulb,
  AlertTriangle,
  Sparkles,
  Angry,
  Frown,
  Smile,
  Wind,
  Anchor,
  Mountain,
  MapPin,
  Sailboat,
} from 'lucide-react';

interface IconMapEntry {
  component: React.ElementType;
  size?: number;
}

const ICON_MAP: Record<string, IconMapEntry> = {
  // Start/Stop/Continue
  '▶️': { component: Play },
  '⏹️': { component: SquarePause },
  '➡️': { component: StepForward },
  '✓': { component: Check },

  // 4Ls
  '❤️': { component: Heart },
  '💡': { component: Lightbulb },
  '⚠️': { component: AlertTriangle },
  '✨': { component: Sparkles },

  // Mad/Sad/Glad
  '😠': { component: Angry },
  '😢': { component: Frown },
  '😊': { component: Smile },

  // Sailboat
  '⛵': { component: Sailboat },
  '💨': { component: Wind },
  '⚓': { component: Anchor },
  '🪨': { component: Mountain },
  '🏝️': { component: MapPin },
};

/**
 * GET Lucide icon component for a given emoji string
 */
export function getIconComponent(
  iconString: string,
  size: number = 20
): React.ReactNode {
  const mapping = ICON_MAP[iconString];

  if (!mapping) {
    // Fallback: return the original emoji if no mapping exists
    return iconString;
  }

  const IconComponent = mapping.component;
  return <IconComponent size={size} />;
}
